import { render, staticRenderFns } from "./GeneralAction.vue?vue&type=template&id=be1126c0"
import script from "./GeneralAction.vue?vue&type=script&lang=ts"
export * from "./GeneralAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports